<div class="text-center mt-5">
  <ngx-spinner></ngx-spinner>
  <p>Procesando autenticación de Google...</p>
</div>
